const SimpleFormContainerComponent = props => (
    //Since SimpleForm child components are rendered in CardContent, we need a basic custom container that renders the form's children
    <>
      {props.children}
    </>
  );

  export default SimpleFormContainerComponent;